import {Method} from 'axios';

export const ROUTER_REDUCER_STATE_ID = 'router';
export const LIBRARY_NAME = '@wallaby-ui/core';

export const METHOD_WITH_REQUEST_BODY: Method[] = [
  'POST',
  'PUT',
  'DELETE',
  'PATCH',
];

export const PAGE_SIZE_SELECT_OPTIONS: number[] = [10, 15, 30, 50, 100];
